import { computed, defineComponent, ref } from "vue";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { ModalStatus } from "@/constants/modal";
import editPen from "@/assets/images/svg/edit-pen-rectangle.svg";
import ModalModule from "@/store/modules/modal";
import BookingModule from "@/store/modules/booking";
export default defineComponent({
  name: "TabNameEditModal",
  setup: function setup() {
    var modalVisibility = dialogVisibleForStatus(ModalStatus.TabNameEdit);
    var tabName = ref("");
    var recentlyUsedNames = computed(function () {
      return BookingModule.recentTabNames;
    });

    function hideModal() {
      ModalModule.setStatus(ModalStatus.Hidden);
    }

    function onSave() {
      BookingModule.setBookingTabName(tabName.value);
      BookingModule.addRecentTabName(tabName.value);
      hideModal();
    }

    function updateNameInput(name) {
      tabName.value = name;
    }

    return {
      modalVisibility: modalVisibility,
      hideModal: hideModal,
      onSave: onSave,
      editPen: editPen,
      tabName: tabName,
      updateNameInput: updateNameInput,
      recentlyUsedNames: recentlyUsedNames
    };
  }
});